import React from 'react';
import { PromoBar } from '../components/PromoBar';
import { Hero } from '../components/Hero';
import { ProofStrip } from '../components/ProofStrip';
import { PainSection } from '../components/PainSection';
import { SystemSection } from '../components/SystemSection';
import { VolumesSection } from '../components/VolumesSection';
import { BonusSection } from '../components/BonusSection';
import { OfferSection } from '../components/OfferSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FaqSection } from '../components/FaqSection';
import { BeforeAfterSection } from '../components/BeforeAfterSection';
import { FinalSection } from '../components/FinalSection';
import { SiteFooter } from '../components/SiteFooter';
import { WhatsAppButton } from '../components/WhatsAppButton';
export function Landing() {
  return <div className="w-full bg-cream" data-id="element-292" data-mp="m8dcsh1fil0t">
      <PromoBar data-id="element-293" data-mp="m58xoomfe4vd" />
      <Hero data-id="element-294" data-mp="29s9glix9sz8" />
      <main data-id="element-295" data-mp="2ajux3it2abs">
        <ProofStrip data-id="element-296" data-mp="2b39qbd5sill" />
        <PainSection data-id="element-297" data-mp="2blfbylpo966" />
        <SystemSection data-id="element-298" data-mp="27nu97fkp7jn" />
        <VolumesSection data-id="element-299" data-mp="3tgl6dd6on5xy" />
        <BonusSection data-id="element-300" data-mp="3tfa2ldd8ly6u" />
        <OfferSection data-id="element-301" data-mp="3tes2g5ngeztn" />
        <TestimonialsSection data-id="element-302" data-mp="3tio64oxn0dfv" />
        <GuaranteeSection data-id="element-303" data-mp="3pe83cwjblm4v" />
        <FaqSection data-id="element-304" data-mp="3pfj7wyklaxx1" />
        <BeforeAfterSection data-id="element-305" data-mp="3pezw7zlj95rg" />
        <FinalSection data-id="element-306" data-mp="3kfn4p1jpvaij" />
      </main>
      <SiteFooter data-id="element-307" data-mp="3kgoopvipn7ce" />
      <WhatsAppButton data-id="element-308" data-mp="3kh7xalmh0jdr" />
    </div>;
}